export default __webpack_public_path__ + "static/media/2472.d1c53297.png";